export const statusLabel = [
  { code: 'UNPAID', label: 'รอการชำระเงิน' },
  { code: 'PAYMENT_FAILED', label: 'ชำระเงินไม่สำเร็จ' },
  { code: 'PAID', label: 'ชำระเงินสำเร็จ' },
  { code: 'PREPARING', label: 'จัดเตรียมสินค้า' },

  { code: 'ASSIGNING_DRIVER', label: 'กำลังหาคนขับ' }, //lalamove -> Assigning driver
  { code: 'ON_GOING', label: 'กำลังมารับสินค้า' }, //lalamove -> On going
  { code: 'SEND', label: 'กำลังส่ง' }, //lalamove -> picked_up
  { code: 'RECEIVED', label: 'รับสินค้าแล้ว' }, //lalamove -> completed

  { code: 'CLOSED', label: 'ยืนยันรับสินค้า' }, // last status
  { code: 'CANCEL', label: 'ยกเลิก' }, //lalamove -> cancelled
  { code: 'LOST', label: 'สินค้าสูญหาย' },
  { code: 'RECALL', label: 'คืนสินค้า' },
  { code: 'RIDER_REJECTED', label: 'หาคนขับไม่ได้' }, //lalamove -> rejected 1
];
